import { CachedObjectState } from "./AdminPageViewModel";
import { useCacheSection } from "./useCacheSection";

export interface Props {
	isPreview: boolean;
	state: CachedObjectState;
}

export const useNavitaireSettingsSection = (props: Props) =>
	useCacheSection({ ...props, actionName: "invalidate_navitairesettings" });
